(function(){
    const $uiFilters = document.querySelectorAll('.ui-filter')
    $uiFilters.forEach(async $f => {
        const {UIFilter} = await import(/*  webpackChunkName: "tabFilter" */'./UIfilter')
        new UIFilter.Filter($f).init()
    })
    const $uiFilterSelections = document.querySelectorAll('.ui-filter-selection')
    $uiFilterSelections.forEach(async $fS => {
        const {UIFilter} = await import(/*  webpackChunkName: "tabFilter" */'./UIfilter')
        new UIFilter.FilterSelection($fS).init()
    })
})()